/* eslint-disable no-param-reassign */
const standardReducers = {};

export default standardReducers;
